module.exports = __webpack_public_path__ + "img/jpg.71dc087d.png";